import { CIcon } from '~/icons/types'
export const ciPaperPlane: CIcon = {
  width: 100,
  height: 100,
  paths: [
    {
      d:
        'M93 .6 2.4 52.8c-3.5 2-3.1 7 .4 8.4L23.6 70l56.1-49.5c1.1-1 2.6.5 1.7 1.6l-47 57.4v15.7c0 4.6 5.6 6.4 8.3 3.1l12.4-15.1 24.3 10.2c2.8 1.2 5.9-.6 6.4-3.6L99.9 5.5c.7-4-3.5-6.8-6.9-4.9z'
    }
  ],
  name: 'paper-plane',
  type: 'solid'
}
